import React from 'react';
import { ASSET_ID_TO_COMPONENT } from '../../icons/registry.generated';
import './SelkirkIcon.css';

/**
 * Renders a Selkirk app icon by manifest asset ID (inline SVG, currentColor).
 */
const SelkirkIcon = ({
  name,
  size = 24,
  className = '',
  title,
  'aria-label': ariaLabel,
  decorative,
  variant,
}) => {
  const Component = ASSET_ID_TO_COMPONENT[name];
  if (!Component) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[SelkirkIcon] Unknown asset id: ${name}`);
    }
    return null;
  }

  const isDecorative = decorative ?? !(title || ariaLabel);
  const a11yProps = isDecorative
    ? { 'aria-hidden': true }
    : { role: 'img', 'aria-label': ariaLabel || title };

  const variantClass =
    variant === 'sm'
      ? 'selkirk-icon--sm'
      : variant === 'nav'
        ? 'selkirk-icon--nav'
        : variant === 'branch'
          ? 'selkirk-icon--branch'
          : '';

  return (
    <span
      className={`selkirk-icon ${variantClass} ${className}`.trim()}
      style={{ width: size, height: size }}
      title={title}
      {...a11yProps}
    >
      <Component width={size} height={size} focusable="false" />
    </span>
  );
};

export default SelkirkIcon;
